import { graphql } from "../gql";

const getHeadToHeadPlayerStatsQuery = graphql(`
  query GetHeadToHeadPlayerStatsTab($input: OddsMarketTypesInput!) {
    event(input: $input) {
      season
      awayTeam {
        numberfireId
        players {
          name
          numberfireId
          position
          jerseyNumber
          teamInfo {
            code
            teamJersey {
              svg
            }
            logo {
              svg
            }
          }
          statistics {
            seasons {
              seasonInfo {
                season
                seasonType
                seasonYear
              }
              seasonStatistics {
                passing {
                  attempts {
                    cumulative
                  }
                  completions {
                    cumulative
                  }
                  interceptions {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                  ratio {
                    percentDisplay
                    percent
                  }
                }
                defense {
                  interceptions {
                    cumulative
                  }
                  passesDefended {
                    cumulative
                  }
                  passingYardsAllowed {
                    cumulative
                  }
                  pointsAllowed {
                    cumulative
                  }
                  rushingYardsAllowed {
                    cumulative
                  }
                  safeties {
                    cumulative
                  }
                }
                fumbles {
                  forced {
                    cumulative
                  }
                  lost {
                    cumulative
                  }
                  recovered {
                    cumulative
                  }
                }
                gamesPlayed
                kicking {
                  extraPoints {
                    attempted {
                      cumulative
                    }
                    made {
                      cumulative
                    }
                    missed {
                      cumulative
                    }
                  }
                  fieldGoals {
                    cumulative {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    fiftyPlusYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    fortyToFortyNineYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    zeroToThirtyNineYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                  }
                }
                receiving {
                  receptions {
                    cumulative
                  }
                  targets {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                }
                rushing {
                  attempts {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                }
                sacks {
                  cumulative
                }
                touchdowns {
                  cumulative
                }
              }
            }
          }
        }
      }
      homeTeam {
        numberfireId
        players {
          name
          numberfireId
          position
          jerseyNumber
          teamInfo {
            code
            teamJersey {
              svg
            }
            logo {
              svg
            }
          }
          statistics {
            seasons {
              seasonInfo {
                season
                seasonType
                seasonYear
              }
              seasonStatistics {
                passing {
                  attempts {
                    cumulative
                  }
                  completions {
                    cumulative
                  }
                  interceptions {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                  ratio {
                    percentDisplay
                    percent
                  }
                }
                defense {
                  interceptions {
                    cumulative
                  }
                  passesDefended {
                    cumulative
                  }
                  passingYardsAllowed {
                    cumulative
                  }
                  pointsAllowed {
                    cumulative
                  }
                  rushingYardsAllowed {
                    cumulative
                  }
                  safeties {
                    cumulative
                  }
                }
                fumbles {
                  forced {
                    cumulative
                  }
                  lost {
                    cumulative
                  }
                  recovered {
                    cumulative
                  }
                }
                gamesPlayed
                kicking {
                  extraPoints {
                    attempted {
                      cumulative
                    }
                    made {
                      cumulative
                    }
                    missed {
                      cumulative
                    }
                  }
                  fieldGoals {
                    cumulative {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    fiftyPlusYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    fortyToFortyNineYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                    zeroToThirtyNineYards {
                      attempted {
                        cumulative
                      }
                      made {
                        cumulative
                      }
                      missed {
                        cumulative
                      }
                    }
                  }
                }
                receiving {
                  receptions {
                    cumulative
                  }
                  targets {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                }
                rushing {
                  attempts {
                    cumulative
                  }
                  touchdowns {
                    cumulative
                  }
                  yards {
                    cumulative
                  }
                }
                sacks {
                  cumulative
                }
                touchdowns {
                  cumulative
                }
              }
            }
          }
        }
      }
      playerPropOdds {
        anyTimeTouchdownScorer {
          selectionId
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        firstTouchdownScorer {
          selectionId
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalPassingYards {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalPassingTDs {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalReceivingYards {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalReceptions {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalRushingYards {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
        totalRushAttempts {
          selectionId
          formattedHandicap
          odds
          runnerName
          runnerStatus
          url
          player {
            name
            numberfireId
            teamInfo {
              name
              teamJersey {
                svg
              }
              logo {
                svg
              }
            }
          }
        }
      }
    }
  }
`);

export default getHeadToHeadPlayerStatsQuery;
